var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tasks-template',{ref:"tasks",attrs:{"tool":"inspector"}})
}
var staticRenderFns = []

export { render, staticRenderFns }